import React from 'react';
import Banner from '../Banner/Banner';
import Overview from '../Overview/Overview';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Overview></Overview>
        </div>
    );
};

export default Home;